import { Context } from "types";

export const deleteClient =
  ({ apiClient }: Context) =>
  (id: string | number) =>
    apiClient({
      url: `/clients/${id}`,
      method: "DELETE",
    });
